export default {
  en: {
    edited: 'edited',
    deleted: 'Message was deleted by %{userName}',
    image_alt: 'Message image',
    official_representative: 'Official representative',
    retry: 'Retry',
    dismiss: 'Dismiss',
    states: {
      error: 'Error',
      initialized: 'Created',
      sending: 'Sending',
      sent: 'Sent',
      persisted: 'Delivered',
      seen: 'Seen',
    },
  },
};
